import { render } from "./PermissionButton.vue?vue&type=template&id=adf24dac&scoped=true"
import script from "./PermissionButton.vue?vue&type=script&lang=js"
export * from "./PermissionButton.vue?vue&type=script&lang=js"

import "./PermissionButton.vue?vue&type=style&index=0&id=adf24dac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adf24dac"]])

export default __exports__